import {Loader, LoadingOverlay} from "@mantine/core";
import {useChecklistData} from "./ChecklistDataContext";
import {CheckItem} from "./CheckItem";
import {NoContent} from "./NoContent";
import type {ChecklistFilterGroup} from "../types";
import styles from "./checklist.module.css";

export const ChecklistTree = ({
    activeFilters,
    onClearSearchAndFilters,
}: {
    activeFilters: ChecklistFilterGroup[];
    onClearSearchAndFilters: () => void;
}) => {
    const {viewFilteredToc, effectiveRootNodeId, isHidden, itemsState, searchTerm} =
        useChecklistData();

    const rootNode = viewFilteredToc[effectiveRootNodeId];
    if (!rootNode) return null;

    const visibleChildren = (rootNode.children ?? []).filter(
        (childId) => !isHidden(childId),
    );

    if (visibleChildren.length === 0) {
        return (
            <div className={styles.checklistTree}>
                <NoContent
                    searchTerm={searchTerm}
                    activeFilters={activeFilters}
                    onClearSearchAndFilters={onClearSearchAndFilters}
                />
            </div>
        );
    }

    return (
        <div className={styles.checklistTree}>
            <LoadingOverlay
                visible={itemsState.fetchingAll}
                loaderProps={{
                    children: <Loader size="sm" color="gneis.5" />,
                }}
            />
            {visibleChildren.map((childId) => (
                <CheckItem
                    key={childId}
                    itemId={childId}
                    parentId={effectiveRootNodeId}
                />
            ))}
        </div>
    );
};
